import React, { Component } from 'react';
import CollapsablePanel from './CollapsePanel';
import EmailTranslation from './EmailTranslation';

class EmailTranslations extends Component {
    render() {
        let { fields, dispatch } = this.props;

        return <div>
            {fields.map((el, idx, all) => {
                let translation = all.getAll()[idx];
                return <div key={idx}>
                    <CollapsablePanel translation={'translation' + idx} section={'translation' + idx} title={`Translation #${idx + 1}`}>
                        <EmailTranslation dispatch={dispatch} translation={translation} el={el} idx={idx} onClick={() => fields.remove(idx)} />
                    </CollapsablePanel>
                </div>
            })}
            <br />

            <button className="btn btn-sm btn-primary"  title="Add a new translation" onClick={() => fields.push({
                subject: `Invoice {invoice_number} from {store_name}`,
                template: `Dear Client,<br/>We issued invoice {invoice_number} for your purchase.
<br/>See the attached invoice PDF file.<br/>
Best Regards,<br/>
{store_name} Team`,
                locationId: -1,
            })}><i className="widget-add-item fa fa-plus-circle" ></i>{""} Add translation</button>
        </div>
    }
}

export default EmailTranslations;



// WEBPACK FOOTER //
// app/containers/EmailTranslations.jsx